const config = {
    host: "https://btb.exploserv.com/api",
    maps_api_key: "AIzaSyCrN9qaWxzLiwIpYx9LqKbHr9trrwvlvT8"
};

export default config;
